module.exports = require('./helpers/bundle-url').getBundleURL('bKm04') + "logo.7718c6df.svg";